import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { getNotificationIdsToMarkRead } from "web_myplann/NotificationCenter/Utils/getNotificationIdsToMarkRead";

export const collectUnreadNotificationIds = (
	items: readonly TimelineItemResponseDTO[],
): number[] => Array.from(new Set(items.flatMap(getNotificationIdsToMarkRead)));
